import { render } from "./TextEditor.vue?vue&type=template&id=541e304e&ts=true"
import script from "./TextEditor.vue?vue&type=script&lang=ts"
export * from "./TextEditor.vue?vue&type=script&lang=ts"

import "./TextEditor.vue?vue&type=style&index=0&id=541e304e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__